import {
  FC, ReactNode,
} from 'react'
import cn from 'classnames'

import style from '@src/components/common/CheckBoxFormik/CheckBoxFormik.module.scss'

type CheckBoxFormikProps = {
  name: string
  type?: string
  label?: string | ReactNode
  className?: string
  value?: string | number
  onChange?: (value?: any) => void
  checked?: boolean
}

export const CheckBoxFormik: FC<CheckBoxFormikProps> = ({
  className, name, type = 'checkbox', label, value, onChange, checked,
}) => (
  <div className={cn(style.box, className)}>
    <label className={style.custom_checkbox}>
      <input
        className={style.custom_checkbox}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <span>
        {' '}
        {label}
      </span>
    </label>
  </div>
)
